import React from 'react';
import PropTypes from 'prop-types';
import EditorField from '../Editor/editor-field';
import { useAppState } from '../../hooks';

// It should render a condition type render a dropdown with no freetext.
// onChange should set the type value in the conditions array, specified by the rowIndex
// onChange should set the value in the conditions array to empty, specified by the rowIndex

function PolicyConditionType(props) {
  const {
    rowItem,
    rowIndex,
    isEditing,
    temporaryPolicy,
    validateObject,
  } = props;

  const { isCcsV2 } = useAppState();

  const CONDITION_TYPES = [
    { type: 'EQUAL' },
    { type: 'NOT_EQUAL' },
    { type: 'LESS_THAN' },
    { type: 'LESS_THAN_OR_EQUAL' },
    { type: 'GREATER_THAN' },
    { type: 'GREATER_THAN_OR_EQUAL' },
    ...(!isCcsV2 ? [{ type: 'IS_IN' }] : [{ type: 'IN' }]),
    ...(!isCcsV2 ? [{ type: 'CONTAINS' }] : []),
  ];

  const selectItem = (type, item) => {
    const newPolicy = { ...temporaryPolicy };
    newPolicy.conditions[rowIndex][type] = item;
    validateObject(newPolicy);
  };

  const selectType = (item) => {
    selectItem('type', item.type, rowIndex);
    switch (item.type) {
      case 'EQUAL':
      case 'NOT_EQUAL':
        selectItem('value', '', rowIndex);
        break;
      case 'CONTAINS':
        selectItem('value', '', rowIndex);
        break;
      case 'IS_IN':
      case 'IN':
        selectItem('value', '[]', rowIndex);
        break;
      default:
        selectItem('value', '0', rowIndex);
    }
  };

  return (
    <EditorField
      isEditing={isEditing}
      value={{ type: rowItem.type }}
      noFreeText
      selectItem={selectType}
      items={CONDITION_TYPES}
    />
  );
}

PolicyConditionType.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  temporaryPolicy: PropTypes.object.isRequired,
  validateObject: PropTypes.func.isRequired,
  rowItem: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
};

export default PolicyConditionType;
